import { VF_INPUT } from 'AppSrc/core/components/forms/form-base-components/v-f-input';
import {
  INLINE_ERRORS,
  // SILENT_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { CHANGE_COORDINATOR_MOBILE_NUMBER } from '../form-definition/section-constants';

const fieldId = CHANGE_COORDINATOR_MOBILE_NUMBER;

// This is only ever used as a read only field and so we never want to validate it
// const validator = () => null;


const initialValues = '';

const vFParams = {
  fieldTitle: 'Change Coordinator Mobile Number',
  characterLimit: 20, // don't forget to add to validator
  placeholder: 'Enter Mobile Number',
};

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_INPUT);
  const overCharacterLimit = commonValidation.textInput.isOverCharacterLimit(values[fieldId], vFParams.characterLimit);

  // const hasSpecialCharacter = commonValidation.textInput.hasSpecialCharacter(values[fieldId]);
  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please enter change cooridnator mobile number' : null);
  errors[INLINE_ERRORS].push((overCharacterLimit) ? 'Text exceeds character limit' : null);
  // errors[INLINE_ERRORS].push((noValue && !optional) ? { withWarningSvg: true, className: 'textarea-area-warning' } : null);
  // errors[SILENT_ERRORS].push((hasSpecialCharacter) ? 'Special character < cannot be accepted in Ace' : null);
  // errors[INLINE_ERRORS].push((hasSpecialCharacter) ? { withWarningSvg: true, className: 'textarea-area-warning' } : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const changeCoordinatorMobileNumber = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_INPUT,
};

export { changeCoordinatorMobileNumber };
